import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initializeSystemTheme } from './theme';
import './style.css';
const stopTheme = initializeSystemTheme();
if (import.meta.hot) import.meta.hot.dispose(stopTheme);
createRoot(document.getElementById('root')!).render(<React.StrictMode><App /></React.StrictMode>);
import './workspace-ipad.css';
import './library-ipad.css';
import './chat-ipad.css';
import './theme.css';
